module.exports = __webpack_public_path__ + "static/media/copy.1e7d5aee.svg";